export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '39e1e104-8e03-4ffc-9fa7-e17545b47618';
export const MODAL_CLOSE_SEC = 2.5;
